export default __webpack_public_path__ + "static/media/SAS Alert Tone 21.1b85230d.wav";